module.exports = __webpack_public_path__ + "static/img/erweima.3c723cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erweima.png
// module id = hMRt
// module chunks = 10